// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_QfYP6 {
    width: 100%;
}

.mainGrid_SPzDs {
    /* display: grid; */
    /* grid-template-columns: 2fr 1fr; */
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 20px;
    padding: 0px 20px;
    min-height: 100vh;
    align-items: start;
}


/* @media (max-width: 1024px) {
    .mainGrid {
        grid-template-columns: 1fr;
    }
} */`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DashboardComponents/Main/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;;;;GAIG","sourcesContent":[".container {\n    width: 100%;\n}\n\n.mainGrid {\n    /* display: grid; */\n    /* grid-template-columns: 2fr 1fr; */\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-bottom: 20px;\n    padding: 0px 20px;\n    min-height: 100vh;\n    align-items: start;\n}\n\n\n/* @media (max-width: 1024px) {\n    .mainGrid {\n        grid-template-columns: 1fr;\n    }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_QfYP6`,
	"mainGrid": `mainGrid_SPzDs`
};
export default ___CSS_LOADER_EXPORT___;
